import { render, staticRenderFns } from "./MentalCheckInductionHoverLink.vue?vue&type=template&id=e124b018&scoped=true&"
import script from "./MentalCheckInductionHoverLink.vue?vue&type=script&lang=ts&"
export * from "./MentalCheckInductionHoverLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e124b018",
  null
  
)

export default component.exports